export class UserQuestionnaire {

    questionarioLabel!: string
    pessoaQuestionarioId!: number
    ordemMensagens!: number[]
    status!: string
    proximaMensagemId!: number

}
